import React from 'react';
import { Card } from '../components/ui/card';
import { Truck, RotateCcw } from 'lucide-react';

export default function ShippingReturns() {
  return (
    <div className="min-h-screen py-12">
      <div className="mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl">
        <h1 className="font-display text-3xl sm:text-4xl text-foreground font-semibold mb-4">Shipping & Returns</h1>
        <p className="text-muted-foreground mb-10">Comprehensive shipping and return information for V watch transactions.</p>

        <section className="mb-10">
          <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center gap-2"><Truck className="h-5 w-5 text-primary" /> Shipping</h2>
          <div className="space-y-4">
            <Card className="p-5 border-border bg-card">
              <h3 className="font-medium text-foreground mb-2">Domestic (UAE)</h3>
              <ul className="text-sm text-muted-foreground space-y-1">
                <li>Delivery: 1-2 business days</li>
                <li>Fully insured for declared value</li>
                <li>Signature required on delivery</li>
                <li>Free shipping on orders above AED 10,000</li>
              </ul>
            </Card>
            <Card className="p-5 border-border bg-card">
              <h3 className="font-medium text-foreground mb-2">International</h3>
              <ul className="text-sm text-muted-foreground space-y-1">
                <li>Delivery: 3-7 business days (varies by destination)</li>
                <li>Shipped via FedEx Priority or Brink's (high-value items)</li>
                <li>Full insurance coverage included</li>
                <li>Import duties and taxes are the responsibility of the buyer</li>
                <li>Restricted countries: Please contact us for availability</li>
              </ul>
            </Card>
            <Card className="p-5 border-border bg-card">
              <h3 className="font-medium text-foreground mb-2">Packaging</h3>
              <p className="text-sm text-muted-foreground">All watches are shipped in tamper-evident, crush-proof packaging. The outer box is unmarked for security — no brand logos or watch imagery. High-value shipments (above $50,000) are handled by armored courier with chain-of-custody documentation.</p>
            </Card>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center gap-2"><RotateCcw className="h-5 w-5 text-primary" /> Returns</h2>
          <div className="space-y-4">
            <Card className="p-5 border-border bg-card">
              <h3 className="font-medium text-foreground mb-2">Return Policy</h3>
              <ul className="text-sm text-muted-foreground space-y-1">
                <li>14-day return window from date of delivery</li>
                <li>Watch must be in the same condition as received</li>
                <li>All original packaging, documentation, and accessories must be included</li>
                <li>Buyer is responsible for return shipping and insurance</li>
                <li>Refund processed within 5 business days of receiving the returned watch</li>
              </ul>
            </Card>
            <Card className="p-5 border-border bg-card">
              <h3 className="font-medium text-foreground mb-2">Non-Returnable Items</h3>
              <ul className="text-sm text-muted-foreground space-y-1">
                <li>Watches that have been worn, scratched, or damaged after delivery</li>
                <li>Custom or modified watches</li>
                <li>Watches without original documentation or accessories</li>
              </ul>
            </Card>
            <Card className="p-5 border-border bg-card">
              <h3 className="font-medium text-foreground mb-2">Disputes</h3>
              <p className="text-sm text-muted-foreground">If the watch received doesn't match the listing description, contact us within 48 hours at support@vwatch.shop. Our team will review the case and arrange a return at the seller's expense if the claim is valid.</p>
            </Card>
          </div>
        </section>
      </div>
    </div>
  );
}
